/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useLayoutEffect, useState } from "react";

/** Components */
import {
  Autocomplete,
  Button,
  ButtonGroup,
  Checkbox,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Grid,
} from "@mui/material";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import CustomDatePicker from "../../commons/CustomDatePicker";
import LoadingProgress from "../../commons/LoadingProgress.component";
import { FilterBy } from "../../commons/filter.component";
import SelectStatusButton, { statusOptions } from "./../../commons/SelectStatusButton";

/** Icons */
import CloseIcon from "@material-ui/icons/Close";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";

/** Api & Function */
import { getGroupVehicles, getOrganizationData, getProvider, postSync, getVehicle, getVehicleById, updateVehicle, updateVehicleStatus, getGrpSparepart, getSparepart } from "./../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";
/** Package */
import moment from "moment";

/** Hook */

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setDataFromBEState } from "../../../store/dataFromBESlice";

import { useParamFilter } from "../../commons/customHook";

const initialFilter = {
  license_plate: null,
  groupvehicle: null,
  organization: null,
  status: null,
};

const tblHeader = ["ID", "Biển số xe", "Nhóm phương tiện", "Tổ chức/Chi nhánh", "Đơn vị vận chuyển", "Trạng thái"];
const tblSparepartHeader = ["STT", "Tên thiết bị", "Số lượng", "Ngày hết hạn", "Ghi chú", "Trạng thái"];

const Vehicles = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [changeIds, setChangeIds] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const { fetchData, data, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50 }, getVehicle);

  //filter
  const [filter, setFilter] = useState({ ...initialFilter });
  const [isOpen, setOpen] = useState(true);

  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };

  const handleUpdateStatus = (selectedStatus) => {
    return updateVehicleStatus({ ids: changeIds, action: selectedStatus.action });
  };

  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      dispatch(setDataFromBEState({ vehicle: data.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)) }));
    }
  };

  const handleRowClick = (e, row) => {
    if (e.target.type === "checkbox") return;
    else {
      /** Change get full infor */
      getVehicleById(row.id).then((res) => {
        if (res.code === 200) setSelectedRow(res.data);
      });
    }
  };

  const handleSearch = () => {
    fetchData({ ...filter, groupvehicle: null, groupvehicle_id: filter.groupvehicle?.id, status: filter.status?.action, organization: null, organization_id: filter.organization?.id });
  };

  const handleEditVehicle = (inputData) => {
    switch (inputData.tab) {
      case 0:
        return updateVehicle(inputData.id, {
          code: inputData.code,
          license_plate: inputData.license_plate,
          organization_id: inputData.organization?.id,
          owner_company: inputData.owner_company?.name,
          provider_id: inputData.owner_company?.id,
          cov: inputData.cov,
          cov_date: inputData.cov_date,
          exp_date: inputData.exp_date,
          capacity: inputData.capacity,
        });
      case 1:
        return updateVehicle(inputData.id, {
          code: inputData.code,
          license_plate: inputData.license_plate,
          organization_id: inputData.organization?.id,
          tanks: inputData.tanks.filter(
            (item) => item.id && item.code && item.weld_side && item.edge_chk_hole && item.edge_chk_line && item.snorkel_no && item.snorkel_side && item.lit && item.barem && item.sub_tanks
          ),
        });
      case 2:
        return updateVehicle(inputData.id, {
          code: inputData.code,
          license_plate: inputData.license_plate,
          organization_id: inputData.organization_id,
          group_sparepart_id: inputData.group_sparepart?.id,
          group_sparepart_name: inputData.group_sparepart?.name,
          sparepart_id: inputData.part?.id,
          sparepart_name: inputData.part?.name,
          sparepart_exp_date: inputData.part?.exp_date,
          quantity: parseInt(inputData.quantity),
          note: inputData.note,
        });
      default:
        break;
    }
  };
  const handleResponseEditVehicle = (res) => {
    if (res.code === 200) {
      setSelectedRow(res.data);
      handleSearch();
    }
  };

  //effect
  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN PHƯƠNG TIỆN VẬN CHUYỂN"));
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <ButtonWithAPICallComponent title="Cập nhật dữ liệu từ ERP" api={() => postSync({ object: "vehicle" })} variant="outlined">
            <RefreshIcon />
          </ButtonWithAPICallComponent>
          <Button onClick={() => setOpen((prev) => !prev)}>
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      {/* filter */}
      <Collapse in={isOpen} sx={{ marginBottom: "20px" }} align="left">
        <FilterBy
          getDataFunc={() => getOrganizationData({ status: 1 })}
          value={filter.organization}
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          label={t("Chi nhánh")}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, organization: newValue }))}
        />
        <FilterBy
          getDataFunc={() => getGroupVehicles({ status: 1 })}
          value={filter.groupvehicle}
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          label={t("Nhóm phương tiện")}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, groupvehicle: newValue }))}
        />
        <TextField
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          InputLabelProps={{ shrink: true }}
          value={filter.license_plate || ""}
          onChange={(e) => setFilter((prev) => ({ ...prev, license_plate: e.target.value }))}
          label={t("Biển số xe")}
        />
        <Autocomplete
          sx={{ display: "inline-flex", minWidth: 200, margin: "5px" }}
          options={statusOptions}
          getOptionLabel={(option) => t(option.label) || ""}
          value={filter.value}
          onChange={(e, newValue) => setFilter((prev) => ({ ...prev, status: newValue }))}
          renderInput={(params) => <TextField {...params} label={t("Trạng thái")} InputLabelProps={{ shrink: true }} />}
        />
        <Button variant="outlined" onClick={handleSearch} style={{ margin: "10px 0" }}>
          {t("Tìm kiếm")}
        </Button>
      </Collapse>
      {loading ? (
        <LoadingProgress />
      ) : (
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {tblHeader.map((item, id) => (
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center" key={id}>
                    {item}
                  </TableCell>
                ))}
                <TableCell style={{ border: "0.5px solid lightgray" }}>
                  <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length ? (
                data.map((row, id) => (
                  <TableRow key={id} hover style={{ cursor: "pointer" }} onClick={(e) => handleRowClick(e, row)}>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id} </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.license_plate}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.groupvehicle_name}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{row.org_name}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                      {row.owner_company}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={handleCheckBoxClick.bind(this, row.id)} />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell align="center" colSpan={20}>
                    {t(isAllow ? "Không có dữ liệu" : "No permission")}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )}
      <EditDialog open={Boolean(selectedRow)} initialData={selectedRow} onClose={() => setSelectedRow(null)} onSave={handleEditVehicle} onSaveResponse={handleResponseEditVehicle} />
    </div>
  );
};

export default Vehicles;

/** Edit Vehilce */

const initialTank = { id: "", lit: "", code: "", weld_side: "", edge_chk_hole: "", edge_chk_line: "", snorkel_no: "", snorkel_side: "", barem: "", sub_tanks: "", exp_date: "" };

const EditDialog = ({ open, onClose, onSave, onSaveResponse, initialData }) => {
  const [t] = useTranslation();

  /** Have setup input Data for when change Tab */
  const [inputData, setInputData] = useState({
    tab: 0,
    vehiclepart_id: null,
  });
  const [dgWidth, setDgWidth] = useState("sm");

  useEffect(() => {
    /** Setup for initialData and Tab 1 */

    if (!initialData) return;
    var tab = inputData.tab;

    /** set  */
    if (tab === 0) setDgWidth("sm");

    /** Set new tank for tab 1 */
    let newTank = initialData.tanks && Array.isArray(JSON.parse(initialData.tanks)) ? JSON.parse(initialData.tanks) : [{ ...initialTank }];

    setInputData({
      ...initialData,
      tab: tab,
      exp_date: initialData.exp_date ? moment(initialData.exp_date).format("YYYY-MM-DD") : null,
      owner_company: null,
      organization: null,
      groupvehicle: null,
      tanks: newTank,
    });
  }, [initialData]);

  const handleResponse = (res) => {
    onSaveResponse && onSaveResponse(res);
  };

  /* Function for 2nd Tab */
  const handleChangeTanks = (index, keyName, newValue) => {
    let newTanks = [...inputData.tanks];
    newTanks[index][keyName] = newValue;
    setInputData((prev) => ({ ...prev, tanks: newTanks }));
  };

  const setDefaultProvider = (option) => {
    const a = option.find((item) => item.id === initialData.provider_id);
    a && setInputData((prev) => ({ ...prev, owner_company: a }));
  };

  const setDefaultOrganization = (option) => {
    const a = option.find((item) => item.id === initialData.organization_id);
    a && setInputData((prev) => ({ ...prev, organization: a }));
  };

  const addNewTank = () => {
    setInputData((prev) => ({ ...prev, tanks: [...prev.tanks, { ...initialTank }] }));
  };

  /** Function for part click */

  const setDefaultGroupSparepart = (option) => {
    const a = option.find((item) => item.id === inputData.group_sparepart_id);
    a && setInputData((prev) => ({ ...prev, group_sparepart: a }));
  };

  const setDefaultSparepart = (option) => {
    const a = option.find((item) => item.id === inputData.part_id);
    a && setInputData((prev) => ({ ...prev, part: a }));
  };

  useLayoutEffect(() => {}, []);

  const handleClickSparepart = (item) => {
    setInputData((prev) => ({ ...prev, group_sparepart_id: item.group_sparepart_id, part_id: item.sparepart_id, quantity: item.quantity, note: item.note, vehiclepart_id: item.id }));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth={dgWidth} fullWidth>
      <DialogTitle align="center">{t("Chỉnh sửa thông tin phương tiện").toUpperCase()}</DialogTitle>
      <DialogContent align="center" style={{ paddingTop: 5 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
          <Tabs value={inputData.tab}>
            <Tab
              label="Thông tin cơ bản"
              onClick={() => {
                setInputData((prev) => ({ ...prev, tab: 0 }));
                setDgWidth("sm");
              }}
            />

            {/* Actice for group 455911 - Truck */}
            <Tab
              label="Thông tin kiểm định"
              disabled={Boolean(initialData?.groupvehicle_id !== 455911)}
              onClick={() => {
                setInputData((prev) => ({ ...prev, tab: 1 }));
                setDgWidth("lg");
              }}
            />
            <Tab
              label="Thông tin thiết bị"
              disabled={Boolean(initialData?.groupvehicle_id !== 5314)}
              onClick={() => {
                setInputData((prev) => ({ ...prev, tab: 2 }));
                setDgWidth("lg");
              }}
            />
          </Tabs>
        </div>
        <div hidden={inputData.tab !== 0} style={{ display: inputData.tab === 0 ? "grid" : "none", rowGap: 10, paddingTop: 10 }}>
          <FilterBy
            fullWidth
            disabled={Boolean(initialData?.groupvehicle_id !== 455911)}
            label={t("Đơn vị vận chuyển")}
            triggerSetDefaultFunc={initialData}
            setDefaultFunc={setDefaultProvider}
            getDataFunc={() => getProvider({ status: 1 })}
            value={inputData.owner_company || null}
            filter={(item) => item.status === "ACTIVATED"}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, owner_company: newValue }))}
          />
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label={t("Biển số xe")}
                alignitems="left"
                onChange={(e) => setInputData((prev) => ({ ...prev, license_plate: e.target.value }))}
                value={inputData?.license_plate || ""}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label={t("Dung tích kiểm định")}
                alignitems="right"
                onChange={(e) => setInputData((prev) => ({ ...prev, capacity: e.target.value }))}
                value={inputData?.capacity || ""}
              />
            </Grid>
          </Grid>

          <FilterBy
            fullWidth
            label={t("Tổ chức")}
            triggerSetDefaultFunc={initialData}
            setDefaultFunc={setDefaultOrganization}
            getDataFunc={() => getOrganizationData({ params: { status: 1 } })}
            // filter={item => item.status === 'ACTIVATED'}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, organization: newValue, organization_id: newValue?.id }))}
            value={inputData?.organization || null}
          />
          <TextField label={t("Số kiểm định")} alignitems="left" fullWidth onChange={(e) => setInputData((prev) => ({ ...prev, cov: e.target.value }))} value={inputData?.cov || ""} />
          <Grid container>
            <Grid item xs={6}>
              <CustomDatePicker label={t("Ngày hết hạn")} value={inputData?.exp_date} onChange={(value) => setInputData((prev) => ({ ...prev, exp_date: value }))} />
            </Grid>
            <Grid item xs={6}>
              <CustomDatePicker label={t("Ngày lập")} value={inputData?.cov_date} onChange={(value) => setInputData((prev) => ({ ...prev, cov_date: value }))} />
            </Grid>
          </Grid>
        </div>
        <div hidden={inputData.tab !== 1}>
          <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>Hầm số</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>Mã số</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>Phía hàn</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>Cách lỗ nhập (mm)</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>Cách đường sinh thấp nhất (mm)</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>Số lượng ống thông hơi</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>Phía đặt ống thông hơi</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>Dung tích</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>Barem cổ téc (l/cm)</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>Số cổ gom</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {inputData.tanks?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <TextField value={item.id} onChange={(e) => handleChangeTanks(index, "id", e.target.value)} />
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <TextField value={item.code} onChange={(e) => handleChangeTanks(index, "code", e.target.value)} />
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <TextField value={item.weld_side} onChange={(e) => handleChangeTanks(index, "weld_side", e.target.value)} />
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <TextField value={item.edge_chk_hole} onChange={(e) => handleChangeTanks(index, "edge_chk_hole", e.target.value)} />
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <TextField value={item.edge_chk_line} onChange={(e) => handleChangeTanks(index, "edge_chk_line", e.target.value)} />
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <TextField value={item.snorkel_no} onChange={(e) => handleChangeTanks(index, "snorkel_no", e.target.value)} />
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <TextField value={item.snorkel_side} onChange={(e) => handleChangeTanks(index, "snorkel_side", e.target.value)} />
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <TextField value={item.lit} onChange={(e) => handleChangeTanks(index, "lit", e.target.value)} />
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <TextField value={item.barem} onChange={(e) => handleChangeTanks(index, "barem", e.target.value)} />
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <TextField value={item.sub_tanks} onChange={(e) => handleChangeTanks(index, "sub_tanks", e.target.value)} />
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }}>
                      <IconButton color="error" onClick={() => inputData.tanks.length > 1 && setInputData((prev) => ({ ...prev, tanks: prev.tanks.filter((_, i) => i !== index) }))}>
                        <CloseIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div style={{ marginTop: 20 }}>
            <Button variant="contained" color="success" onClick={addNewTank}>
              {t("Thêm")}
            </Button>
          </div>
        </div>
        <div hidden={inputData.tab !== 2}>
          <Grid container style={{ marginTop: 20 }}>
            <Grid item xs={8}>
              <TableContainer component={Paper} style={{ width: "100%" }} sx={{ maxHeight: 800 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {tblSparepartHeader.map((item, id) => (
                        <TableCell align="center" style={{ border: "0.5px solid lightgray" }} key={id}>
                          {item}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  {initialData?.sparepart?.map((item, id) => (
                    <TableBody key={id}>
                      <TableRow>
                        <TableCell align="left" colSpan={6} style={{ border: "0.5px solid lightgray" }}>
                          <b>Nhóm: {item.group_sparepart_name}</b>
                        </TableCell>
                      </TableRow>
                      {item.parts.map((subitem, subid) => (
                        <TableRow key={subid} hover style={{ cursor: "pointer" }} onClick={() => handleClickSparepart(subitem)}>
                          <TableCell style={{ border: "0.5px solid lightgray" }}>{subid + 1}</TableCell>
                          <TableCell align="left" style={{ border: "0.5px solid lightgray" }}>
                            {subitem.sparepart_name}
                          </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="right">
                            {t(subitem.quantity)}
                          </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }}>{moment(subitem.exp_date).format("DD/MM/YYYY")}</TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                            {t(subitem.note)}
                          </TableCell>
                          <TableCell style={{ border: "0.5px solid lightgray" }}>{t(subitem.status)}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  ))}
                </Table>
              </TableContainer>
            </Grid>

            <Grid item xs={4} style={{ border: "0.5px solid lightgray" }}>
              <FilterBy
                style={{ margin: 10, width: "95%" }}
                label={t("Nhóm thiết bị")}
                getDataFunc={() => getGrpSparepart({ status: 1 })}
                triggerSetDefaultFunc={inputData.group_sparepart_id}
                setDefaultFunc={setDefaultGroupSparepart}
                value={inputData?.group_sparepart || null}
                onChange={(e, newValue) => setInputData((prev) => ({ ...prev, group_sparepart: newValue }))}
              />
              <FilterBy
                disabled={!inputData.group_sparepart}
                style={{ margin: 10, width: "95%" }}
                label={t("Thiết bị")}
                getDataFunc={() => getSparepart({ status: 1, group_sparepart_id: inputData.group_sparepart?.id })}
                triggerSetDefaultFunc={inputData.part_id}
                setDefaultFunc={setDefaultSparepart}
                getDataDependencies={[inputData.group_sparepart]}
                value={inputData.part || null}
                onChange={(e, newValue) => setInputData((prev) => ({ ...prev, part: newValue }))}
              />
              <TextField
                style={{ margin: 10, width: "95%" }}
                InputLabelProps={{ shrink: true }}
                label={t("Số lượng")}
                alignitems="right"
                onChange={(e) => setInputData((prev) => ({ ...prev, quantity: e.target.value }))}
                value={inputData?.quantity || ""}
              />
              <TextField
                style={{ margin: 10, width: "95%" }}
                InputLabelProps={{ shrink: true }}
                label={t("Ghi chú")}
                alignitems="left"
                onChange={(e) => setInputData((prev) => ({ ...prev, note: e.target.value }))}
                value={inputData?.note || ""}
              />
              {inputData.vehiclepart_id && (
                <Button
                  color="warning"
                  onClick={() => setInputData((prev) => ({ ...prev, vehiclepart_id: null, part: null, group_sparepart: null, group_sparepart_id: null, part_id: null, quantity: null, note: null }))}
                >
                  <CancelIcon />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="warning" onClick={onClose}>
          {t("Hủy")}
        </Button>
        {inputData.vehiclepart_id && (
          <Button variant="contained" color="error" onClick={onClose}>
            {t("Xoá")}
          </Button>
        )}
        <ButtonWithAPICallComponent variant="contained" api={() => onSave(inputData)} response={handleResponse}>
          {t("Lưu")}
        </ButtonWithAPICallComponent>
      </DialogActions>
    </Dialog>
  );
};
